module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content-header",
    staticStyle: {
      "height": "50px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left",
      "padding-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12"
  }, [_c('va-box', {
    attrs: {
      "title": "Dealer Information",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.dealerInfo), function(item) {
    return _c('div', {
      staticClass: "col-sm-12",
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, [_c('span', {
      staticClass: "description-text"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "description-block",
      staticStyle: {
        "background-color": "#eee",
        "padding": "5px",
        "margin": "0px",
        "height": "30px"
      }
    }, [_c('b', {
      staticClass: "text-right pull-right",
      domProps: {
        "innerHTML": _vm._s(item.value)
      }
    })])])
  }), 0)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12"
  }, [_c('va-box', {
    attrs: {
      "title": "Dealer Progress",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.dealerProgress), function(item) {
    return _c('div', {
      staticClass: "col-sm-12",
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, [_c('span', {
      staticClass: "description-text"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "description-block",
      staticStyle: {
        "background-color": "#eee",
        "padding": "5px",
        "margin": "0px",
        "height": "30px"
      }
    }, [_c('b', {
      staticClass: "text-right pull-right",
      domProps: {
        "innerHTML": _vm._s(item.value)
      }
    })])])
  }), 0)])], 1), _vm._v(" "), (0 > 1) ? _c('div', {
    staticClass: "col-lg-5 col-md-5 col-sm-12"
  }, [(_vm.showImage) ? _c('div', [_c('va-box', {
    attrs: {
      "title": "Printer Image",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question",
      "tooltip": _vm.tooltip.printerInfo,
      "imagesList": _vm.images
    },
    on: {
      "imageChanged": _vm.imageChanged
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('img', {
    ref: "printerImage",
    staticStyle: {
      "width": "100%",
      "min-height": "300px",
      "max-height": "500px"
    },
    attrs: {
      "src": _vm.printer.imgUrl
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loadingImage,
      "is-full-page": _vm.isFullpage
    },
    on: {
      "update:active": function($event) {
        _vm.loadingImage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" "), _c('span', [_vm._v("Saving image...")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('va-box', {
    attrs: {
      "title": "Printer Status",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question",
      "tooltip": _vm.tooltip.printerStatus
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.printerStatus), function(item) {
    return _c('div', {
      staticClass: "col-sm-12",
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, [_c('span', {
      staticClass: "description-text"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "description-block",
      staticStyle: {
        "background-color": "#eee",
        "padding": "5px",
        "margin": "0px",
        "height": "30px"
      }
    }, [_c('b', {
      staticClass: "text-right pull-right"
    }, [_vm._v(_vm._s(item.value))])])])
  }), 0)])], 1), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Printer Toners",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question",
      "tooltip": _vm.tooltip.printerToners
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.printerToners), function(item) {
    return _c('div', {
      staticClass: "col-sm-3"
    }, [_c('div', {
      staticClass: "description-block",
      staticStyle: {
        "padding": "5px",
        "height": "50px"
      }
    }, [_c('span', {
      staticClass: "col-sm-5 description-text text-left"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', {
      staticClass: "progress-group",
      staticStyle: {
        "width": "80px"
      }
    }, [_c('div', {
      staticClass: "progress sm",
      staticStyle: {
        "background-color": "#ccc",
        "height": "20px"
      }
    }, [(item.value >= 0) ? _c('div', {
      class: ['progress-bar', 'progress' + item.title],
      style: ({
        width: item.value + '%'
      })
    }, [_vm._v(_vm._s(item.value) + "%")]) : _c('div', [_vm._v("N/A")])])])])])])
  }), 0)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Printer Properties",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question",
      "tooltip": _vm.tooltip.printerProps
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.printerProps), function(printerProp) {
    return _c('div', {
      staticClass: "col-sm-4",
      on: {
        "click": function($event) {
          printerProp.Value = !printerProp.Value
        }
      }
    }, [_c('div', {
      staticClass: "tree-content tree--small",
      staticStyle: {
        "float": "left!important"
      }
    }, [_c('i', {
      class: ['tree-checkbox', printerProp.Value ? 'checked' : '']
    }), _vm._v(" "), _c('span', {
      staticClass: "tree-anchor",
      attrs: {
        "tabindex": "-1"
      }
    }, [_c('span', {
      staticClass: "tree-text",
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(printerProp.Key))])])])])
  }), 0), _vm._v(" "), (_vm.$root.isAdmin || _vm.$root.isDealer) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelType($event)
      }
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "name": "Save",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveType($event)
      }
    }
  })], 1) : _vm._e()])], 1) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7169567c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dealer.vue
// module id = 724
// module chunks = 0